export default __webpack_public_path__ + "static/media/diners.cfdc3a29.png";